export class LogsClient {
    private worker: SharedWorker;

    constructor() {
      this.worker = new SharedWorker("/workers/logs.worker.js");
    }

    public push(message: { level: "info" | "error" | "warn" | "debug" | "trace", message: string, location: string }) {
      this.worker.port.postMessage(message);
    }
}